import { render } from "./Card.vue?vue&type=template&id=4fc905cd&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=4fc905cd&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc905cd"]])

export default __exports__